import { observer } from 'mobx-react';

const FooterMenu = observer(({ name, items }) => {
  // Do not render the component if the name is missing
  if (!name) return null;

  return (
    <div className="py-2 px-4 sm:p-3 md:p-4 md:w-1/4 mb-4 md:mb-0">
      <h4 className="text-xl mb-3 font-secondary">{name}</h4>
      {items && items.length > 0 ? (
        <ul>
          {items.map((item) => (
            <li key={item.id} className="mb-2">
              <a href={item.url} className="hover:underline">
                {item.title}
              </a>
            </li>
          ))}
        </ul>
      ) : (
        <p className="text-gray-500">No items available.</p>
      )}
    </div>
  );
});

export default FooterMenu;
